(function($) {

  $(function() {

    $('.widget--sidebar .widget__title').on('click', function(e) {
      e.preventDefault();
      $(this).closest('.widget').toggleClass('widget--active');
    });

    $('a[href*="#"]').not('[href^="#tab"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      // On-page links
      if ( location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });

    $('.nav-link .search-form').on('click', function(e) {
      var $navbar = $(this).closest('.navbar');

      if( $navbar.hasClass('navbar--search-active') ) {

      } else {
        $navbar.addClass('navbar--search-active');
        e.preventDefault();
        $(this).find('input').focus();
      }
    });

    $('.shopping-cart > a').on('click', function(e) {
      var $shoppingCart = $(this).parent();

      if( $shoppingCart.hasClass('shopping-cart--active') ) {

      } else {
        $shoppingCart.addClass('shopping-cart--active');
        e.preventDefault();
      }
    });

    $('#ywapo_value_1 input').on('change', function(e) {
      if( $(this).is(':checked') ) {
        $('#ywapo_value_2').slideDown();
      } else {
        $('#ywapo_value_2').slideUp();
      }
    });

    var otherProducts = $('.other-products__products').slick({
      mobileFirst: true,
      dots: true,
      arrows: false,
      speed: 500,
      infinite: false,
      centerMode: false,
      slidesToShow: 1.1,
      responsive: [
        {
          breakpoint: 424,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });

    $('.other-products__products li').each(function() {
      var currentProduct = $('div.product').attr('id').split('-')[1];
      if( $(this).hasClass('post-' + currentProduct) ) {
        $(this).addClass('product--current');
        $('.other-products__products').slick('slickGoTo', $(this).index() );
      }

    });

    $('.related ul.products').slick({
      mobileFirst: true,
      dots: true,
      arrows: false,
      speed: 500,
      infinite: false,
      centerMode: false,
      slidesToShow: 1.1,
      responsive: [
        {
          breakpoint: 424,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 991,
          settings: "unslick"
        }
      ]
    });

  });

})(jQuery);
